import React, { useState } from 'react';
import HorizontalNav from './HorizontalNav';
import TopBar from './TopBar';
import AIChat from '../AIChat';

const Layout = ({ children }) => {
  const [showAIChat, setShowAIChat] = useState(false);

  return (
    <div className="min-h-screen bg-white">
      {/* Top Bar */}
      <TopBar 
        onOpenSkyBot={() => setShowAIChat(true)}
      />

      {/* Horizontal Navigation Menu */}
      <div className="fixed top-14 left-0 right-0 z-40">
        <HorizontalNav />
      </div>

      {/* Main Content */}
      <main className="pt-24">
        <div className="p-6">
          {children}
        </div>
      </main>

      {/* AI Chat */}
      <AIChat isOpen={showAIChat} onClose={() => setShowAIChat(false)} />
    </div>
  );
};

export default Layout;
